export const urlSearchParams = {
    launchUrl: 'launchUrl',
    errorType: 'error',
    errorDesc: 'error_description'
};
